<template>
	<div class="btn-toolbar pull-left" role="toolbar">
		<div class="btn-group form-inline" role="group" aria-label="...">
			<input type="checkbox" v-model="filter.unavalible">
				No disponible
			<input @keyup="keyUpdoFilter($event)" v-model="filter.text" type="text" class="form-control" placeholder="Buscar...">
		</div>

		<div class="btn-group" role="group" aria-label="...">
			<button
				title="Filtrar"
				ref="btnfilter"
				@click="doFilter()"
				data-style="slide-left"
				class="btn btn-success">
				<i class="fa fa-search" aria-hidden="true"></i>
			</button>
			<button
				title="Restablecer"
				ref="btnreset"
				@click="reset()"
				data-style="slide-left"
				class="btn btn-default">
				<i class="fa fa-refresh" aria-hidden="true"></i>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	props: ['user', 'isAuth', 'filter'],
	data () {
		return {
		}
	},
	watch: {
		'filter.unavalible': function() {
			this.$emit('filterSet', this.filter)
		},
	},
	methods: {
		keyUpdoFilter(event) {
				if(this.filter.text) {
					if(event.code == 'Enter') {
						this.doFilter()
					} else {
						if(event.code != 'Space') {
							if(this.filter.text.length > 2) {
								this.doFilter()
							}
						}
					}
				} else {
					this.doFilter()
				}
		},
		doFilter() {
			this.filter.text = this.filter.text.trimStart()
			this.$emit('filterSet', this.filter)
		},
		reset() {
			this.clearData()
			this.$emit('filterReset')
		},
		clearData() {
			this.filter.text = null
			this.filter.unavalible = false
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/users/views/FilterBar.vue